import React from "react";

import { GoogleTagManagerBlock as Value } from "@reactivated";

import styles from "./GoogleTagManagerBlock.module.scss";

export const GoogleTagManagerBlock = (props: {
    id: string;
    value: Value;
    cspNonce?: string | null;
}): React.JSX.Element[] => {
    if (!props.value.container_id) {
        return [];
    }
    return [
        <script
            key={`${props.id}-default`}
            type="text/javascript"
            nonce={props.cspNonce || undefined}
        >{`
                dataLayer = [];
                (function(w, d, s, l, i) {
                    w[l] = w[l] || [];
                    w[l].push({
                        'gtm.start':
                        new Date().getTime(),
                        event: 'gtm.js'
                    });
                    var f = d.getElementsByTagName(s)[0],
                        j = d.createElement(s),
                        dl = l != 'dataLayer' ? '&l=' + l : '';
                    j.async = true;
                    j.src =
                    'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
                    f.parentNode.insertBefore(j, f);
                })(window, document, 'script', 'dataLayer', '${props.value.container_id}');
        `}</script>,
        <noscript key={`${props.id}-noscript`}>{`
            <iframe
                src="https://www.googletagmanager.com/ns.html?id=${props.value.container_id}"
                height="0"
                width="0"
                class="${styles.gtmIframe}"
            ></iframe>
        `}</noscript>,
    ];
};
